const COMMENTS_DATA = [
  {
    name: '吃瓜一线猹',
    avatar: 'C',
    avatarBg: 'bg-primary-500',
    time: '2小时前',
    content: '这个平台更新速度真的快！刚看到热搜这里就有了高清视频，画质也超好，已经推荐给身边所有吃瓜小伙伴了。',
    likes: 326,
  },
  {
    name: '围观群众小王',
    avatar: '王',
    avatarBg: 'bg-accent-500',
    time: '5小时前',
    content: '每天必刷的吃瓜网站，更新的内容比别家全多了。黑料吃瓜短视频刷起来特别上头，根本停不下来。',
    likes: 218,
  },
  {
    name: '娱乐圈百晓生',
    avatar: '晓',
    avatarBg: 'bg-secondary-500',
    time: '8小时前',
    content: '在这个平台跟了好几个月的瓜了，信息量巨大，而且分类很清楚。高清播放体验也很稳定。',
    likes: 195,
  },
  {
    name: '深夜吃瓜人',
    avatar: '夜',
    avatarBg: 'bg-primary-400',
    time: '12小时前',
    content: '晚上睡不着就喜欢来这里刷黑料吃瓜最新视频，内容更新快而且不卡顿，感觉比看电视剧还有意思。',
    likes: 147,
  },
  {
    name: '八卦小雷达',
    avatar: '雷',
    avatarBg: 'bg-accent-400',
    time: '1天前',
    content: '对比了好几个同类平台，还是这里最对我胃口。专题做的用心，评论区也很有意思，已经安利给姐妹们了。',
    likes: 89,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            <i className="ri-chat-smile-2-line text-accent-500 mr-2"></i>读者热评
          </h2>
          <p className="mt-2 text-sm text-foreground-500">看看吃瓜群众们都在聊什么</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {COMMENTS_DATA.slice(0, 3).map((comment, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/60 rounded-xl p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className={`w-10 h-10 rounded-full ${comment.avatarBg} flex items-center justify-center text-white font-bold text-sm shrink-0`}>
                  {comment.avatar}
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-800">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
              <div className="mt-3 flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}

          {COMMENTS_DATA.slice(3).map((comment, idx) => (
            <div
              key={idx + 3}
              className="bg-background-50 border border-background-200/60 rounded-xl p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className={`w-10 h-10 rounded-full ${comment.avatarBg} flex items-center justify-center text-white font-bold text-sm shrink-0`}>
                  {comment.avatar}
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-800">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
              <div className="mt-3 flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}